import React from 'react';

import { Card } from '@ergeon/core-components';
import { HelpNodeDetails, HelpToc } from '@ergeon/help-components';

import { WIKI_API_HOST } from '../constants';
import { WikiNode } from '../types';

import LocalSearchForm from './LocalSearchForm';
import { Heading, TOC_TITLE } from './headings';

type NodeRailProps = {
  headings: Heading[];
  node: WikiNode | null;
};

const NodeRail = ({ headings, node }: NodeRailProps) => {
  if (!node) {
    return null;
  }

  return (
    <div className="sticky top-24 flex flex-col gap-4">
      {headings.length > 0 && (
        <Card className="flex-col p-4" rounded="medium">
          <HelpToc headings={headings} title={TOC_TITLE} />
        </Card>
      )}
      <Card className="flex-col p-4" rounded="medium">
        <HelpNodeDetails apiHost={WIKI_API_HOST} isPrivate node={node} />
      </Card>
      <LocalSearchForm nodeKey={node.nodeKey} />
    </div>
  );
};

export default NodeRail;
